export const TYPE_TO_ROUTE = {
  story: 'stories',
  project: 'projects',
  article: 'articles',
  video: 'videos',
  blog: 'blog',
  announcement: 'blog'
};
